(function () {
  const product_lists = document.querySelectorAll('.product-list');
  if(product_lists) {
    var card_list_heights = function() {
      product_lists.forEach(product_list => {
        var sd_height = 188;
        var $short_desc = product_list.querySelectorAll('.short-description');
        if($short_desc) {
          for (i = 0; i < $short_desc.length; i++) {
            var $sd_height = $short_desc[i].offsetHeight;
            sd_height = $sd_height > sd_height ? $sd_height : sd_height;
          }
          for (i = 0; i < $short_desc.length; i++) {
            $short_desc[i].style.minHeight = `${sd_height}px`;
          }
        }
        
        var ct_height = 26;
        var $cart_title = product_list.querySelectorAll('.product-block--data .title');
        if($cart_title) {
          for (i = 0; i < $cart_title.length; i++) {
            var $ct_height = $cart_title[i].offsetHeight;
            ct_height = $ct_height > ct_height ? $ct_height : ct_height;
          }
          for (i = 0; i < $cart_title.length; i++) {
            $cart_title[i].style.minHeight = `${ct_height}px`;
          }
        }
        
        var cb_height = 0;
        var $card_bullets = product_list.querySelectorAll('.product-block--card-bullets');
        if($card_bullets) {
          for (i = 0; i < $card_bullets.length; i++) {
            var $cb_height = $card_bullets[i].offsetHeight;
            cb_height = $cb_height > cb_height ? $cb_height : cb_height;
          }
          for (i = 0; i < $card_bullets.length; i++) {
            $card_bullets[i].style.minHeight = `${cb_height}px`;
          }
        }
      });
    }
    card_list_heights();
    window.addEventListener('resize', function(event) {
      card_list_heights();
    }, true);
  }


if (window.location.pathname.includes('customers/login.json')) {
  var anchorSelector = document.querySelectorAll('a[href*="#"]');
  anchorSelector.forEach(link => {
    link.onclick = function (e) {
      let hash = link.getAttribute('href').split('#');
      if (hash.length > 1 && hash[1] !== '' && hash[1] !== '#') {
        e.preventDefault(); // Prevent default anchor behavior
        if (hash[1] === 'top') {
          hash[1] = 'page-content'; 
        }
        let destination = document.getElementById(hash[1]);
        if (destination) {
          const y = destination.getBoundingClientRect().top + window.pageYOffset - 180;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }
    };
  });
} else {
  if (window.location.hash) {
    // scroll(0, 0);
    // window.scrollTo({top: 0});
    // setTimeout(scroll(0, 0), 1);
    var hashLink = window.location.hash;
    if (document.querySelector(hashLink)) {
      let destination =  document.querySelector(hashLink);
      setTimeout(function() {
        const y = destination.getBoundingClientRect().top + window.pageYOffset - 180;
        window.scrollTo({top: y, behavior: 'smooth'})
      }, 200);;
    }
  }
  let anchorSelector = 'a.header-nav__tier-2-link[href*="#"]';
  let anchorList = document.querySelectorAll(anchorSelector);
  anchorList.forEach(link => {
    link.onclick = function (e) {
      let hash = link.getAttribute('href').split('#');
      if(window.location.pathname.includes(hash[0])) {
        e.preventDefault();
        let destination =  document.getElementById(hash[1]);
        const y = destination.getBoundingClientRect().top + window.pageYOffset - 180;
        window.scrollTo({top: y, behavior: 'smooth'});
      }
    }
  });
}

})();